import {
  Add as AddIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Checklist as ChecklistIcon,
  Gavel as GavelIcon,
  AttachMoney as AttachMoneyIcon,
} from "@mui/icons-material";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const CadastroDados = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const entidades = [
    {
      id: "tipos-licenca",
      nome: "Tipos de Licença",
      descricao: "Cadastre e gerencie os tipos de licenças disponíveis",
      icon: AssignmentIcon,
      rota: "/analista/cadastro-dados/tipos-licenca",
      cor: theme.palette.primary.main,
    },
    {
      id: "Checklist",
      nome: "Checklists",
      descricao:
        "Adição de Checklists para auxiliar na análise de requerimentos.",
      icon: ChecklistIcon,
      rota: "/analista/cadastro-dados/checklist",
      cor: theme.palette.warning.main,
    },
    {
      id: "pdflayout",
      nome: "PDF Layout",
      descricao: "Configure os templates de layouts para geração de PDFs",
      icon: DescriptionIcon,
      rota: "/analista/cadastro-dados/pdf-layout",
      cor: theme.palette.secondary.main,
    },
    {
      id: "auto-infracao",
      nome: "Auto de Infração",
      descricao: "Cadastre e gerencie os autos de infração",
      icon: GavelIcon,
      rota: "/analista/cadastro-dados/auto-infracao",
      cor: theme.palette.error.main,
    },
    {
      id: "taxas-checklist",
      nome: "Taxas de Tipo de Licença",
      descricao: "Configure as taxas de valores para tipos de licença",
      icon: AttachMoneyIcon,
      rota: "/analista/cadastro-dados/taxas-checklist",
      cor: theme.palette.success.main,
    },
    {
      id: "checklist-autorizacao",
      nome: "Checklist de Autorização",
      descricao:
        "Cadastre e gerencie os checklists das solicitações de autorização.",
      icon: ChecklistIcon,
      rota: "/analista/checklist-autorizacao",
      cor: theme.palette.info.main,
    },
  ];

  const handleSelectEntity = (rota) => {
    navigate(rota);
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: { xs: 2, md: 4 },
        mb: { xs: 2, md: 4 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          mb: { xs: 3, md: 4 },
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <AddIcon
          sx={{
            fontSize: { xs: 28, md: 32 },
            mr: { xs: 1, md: 2 },
            color: theme.palette.primary.main,
          }}
        />
        <Typography
          variant="h4"
          component="h1"
          fontWeight="bold"
          color="primary.main"
          sx={{ fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.125rem" } }}
        >
          Cadastro de Dados
        </Typography>
      </Box>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: { xs: 3, md: 4 } }}
      >
        Selecione a entidade que deseja cadastrar ou editar:
      </Typography>

      <Grid container spacing={{ xs: 2, md: 3 }}>
        {entidades.map((entidade) => {
          const IconComponent = entidade.icon;
          return (
            <Grid item xs={12} sm={6} md={6} lg={4} key={entidade.id}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  border: `2px solid ${alpha(entidade.cor, 0.2)}`,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
                    transform: "translateY(-4px)",
                    borderColor: entidade.cor,
                  },
                  cursor: "pointer",
                }}
              >
                <CardActionArea
                  onClick={() => handleSelectEntity(entidade.rota)}
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      pt: 3,
                      flexGrow: 1,
                    }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: "50%",
                        backgroundColor: alpha(entidade.cor, 0.1),
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconComponent
                        sx={{
                          fontSize: 40,
                          color: entidade.cor,
                        }}
                      />
                    </Box>

                    <Typography
                      variant="h6"
                      component="h2"
                      fontWeight="bold"
                      sx={{ mb: 1, color: entidade.cor }}
                    >
                      {entidade.nome}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: 2,
                        flexGrow: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {entidade.descricao}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default CadastroDados;
